import angular from 'angular';
import { isArray, isObject, keys } from 'lodash';

module.exports = angular.module('common.filters.length', [])
.filter('length', function() {
  return function(input) {
    if (isArray(input)) {
      return input.length;
    } else if (isObject(input)) {
      return keys(input).length;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/length.js
 **/